import React, { useEffect, useRef, useState } from 'react';
import { Card, Grid, Paper, Typography } from '@mui/material';
import BakeasyTextField from '../../components/textfields/BakeasyTextField';
import { AppContext } from '../../context/AppContext';
import BakeasyEmptyMsg from '../../components/common/BakeasyEmptyMsg';
import BakeasyHeaderLabel from '../../components/lables/BakeasyHeaderLabel';
import {
  BakeasyChipDelete,
  BakeasyChipEdit,
} from '../../components/common/BakeasyChip';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  BakeasyImgSelector,
  BakeasyImgSelectorView,
  ImageUploadMessage,
} from '../../components/common/BakeasyImgSelect';
import * as Regex from '../../constants/Regex';
import { uploadFile } from '../../ApiServices/ProductsService';
import { t } from 'i18next';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  categoryState,
  fetchCategories,
} from '../../redux_store/slices/categorySlice';
import {
  clearSubCategoryState,
  fetchSubCategories,
  subCategoryState,
} from '../../redux_store/slices/subCategorySlice';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import {
  addProduct,
  clearProductState,
  downloadProductDetails,
  fetchProductById,
  fetchProductNames,
  modifyProduct,
  productsState,
} from '../../redux_store/slices/productsSlice';
import { BakeasyAppBar } from '../../components/common/BakeasyAppBar';
import BakeasySimpleTable from '../../components/tables/BakeasySimpleTable';
import { PRODUCT_STATUS_ARRAY, UNAUTHORIZED } from '../../constants/Constants';
import { authActions, authState } from '../../redux_store/slices/authSlice';
import {
  BakeasyButtonClear,
  BakeasyButtonAdd,
  BakeasyButtonCancel,
  BakeasyButtonUpdate,
  BakeasyButtonCreate,
  BakeasyButtonDuplicate,
  BakeasyButtonPrint,
} from '../../components/buttons/BakeasyButton';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import * as Dropdown from '../../components/dropdowns/BakeasySelect';
import {
  BakeasyAutoCompleteCategoryA,
  BakeasyAutoCompleteIngredient,
  BakeasyAutoCompleteProductName,
  BakeasyAutoCompleteSubCategoryA,
  BakeasyAutoDeliveryTimeframe,
  BakeasyAutoUnitOfMeasure,
} from '../../components/dropdowns/BakeasyAutoComplete';
import * as Button from '../../components/buttons/BakeasyButtons';
import {
  clearIngredientsState,
  fetchIngredients,
  ingredientsState,
} from '../../redux_store/slices/ingredientsSlice';
import BakeasyDivider from '../../components/common/BakeasyDivider';
import BakeasyLabelText from '../../components/lables/BakeasyLabelText';
import {
  prepareDemicalNumber,
  validateField,
} from '../../utils/ValidationUtils';
import {
  ingredientTableHeaders,
  ingredientTableHeadersForView,
} from '../../constants/TableHeaders';
import { hideLoader, showLoader } from '../../redux_store/slices/loaderSlice';
import { dropdownDataState } from '../../redux_store/slices/dropdownDataSlice';
import i18n from '../../languages/languages';
import { getCurrency } from '../../utils/commonUtils';
import { getProfileState } from '../../redux_store/slices/GetUserProfileSlice';

export const CreateProduct = (props: any) => {
  const formRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isView, setIsView] = useState<boolean>(false);

  const [selectedStatus, setSelectedStatus] = useState<any>('');
  const [selectedTimeframe, setSelectedTimeframe] = useState<any>('');
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState<any>(null);
  const [selectedProductType, setSelectedProductType] = useState<any>('');
  const [recipeBuilder, setRecipeBuilder] = useState<any>('');
  const [recipeBuilderType, setRecipeBuilderType] = useState<any>('');
  const [ingredientList, setIngredientList] = useState<any[]>([]);
  const [description, setDescription] = useState<any>('');
  const [productName, setProductName] = useState<any>('');
  const [productId, setProductId] = useState<any>('');
  const [retailPrice, setRetailPrice] = useState<any>(0);
  const [ingredientName, setIngredientName] = useState<any>('');
  const [productCost, setProductCost] = useState<any>('');
  const [unitsOfMeasure, setUnitsOfMeasure] = useState<any>('');
  const [ingQuantity, setIngQuantity] = useState<any>('');
  const [price, setPrice] = useState<any>('');
  const [skuNumber, setSkuNumber] = useState<any>('');
  const [selectedProductImageFile, setSelectedProductImageFile] = useState<
    File | string | null
  >(null);
  const [selectedIngredientImage, setSelectedIngredientImage] = useState<
    File | string | null
  >(null);
  const [selectedNutritionImage, setSelectedNutritionImage] = useState<
    File | string | null
  >(null);
  const [skuImage, setSelectedSkuImage] = useState<File | string | null>(null);
  const [qrCode, setSelectedQrCode] = useState<File | string | null>(null);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [supplierName, setSupplierName] = useState('');

  const [productData, setProductData] = useState<any>();
  const [productNameLabel, setProductNameLabel] = useState<string>(
    productName || ''
  );
  const [newlycreatedingredient, setNewlycreatedingredient] = useState<any>('');

  let { error, selectedValue } = useAppSelector(productsState);
  let _categoryState = useAppSelector(categoryState);
  let _subCategoryState = useAppSelector(subCategoryState);
  let _ingredientsState = useAppSelector(ingredientsState);
  let _authState = useAppSelector(authState);
  let _productState = useAppSelector(productsState);
  let _dropdownDataState = useAppSelector(dropdownDataState);
  let _userProfile: any = useAppSelector(getProfileState);

  useEffect(() => {
    setIsEdit(location?.state?.isEdit);
    setIsView(location?.state?.isView);

    if (location?.state?.isEdit === true || location?.state?.isView === true) {
      fetchData(location?.state?._id);
    }

    if (
      location?.state?.isEdit === false &&
      location?.state?.isView === false
    ) {
      dispatch(clearIngredientsState());
      dispatch(fetchCategories({ page: 1, limit: 5 }));
      dispatch(fetchProductNames({ limit: 5 }));
    }

    if (!_authState?.value?.userDetails?.userInfo?.isReceipeBuilder) {
      setRecipeBuilder('No');
    }

    if (_authState?.value?.userDetails?.userInfo?.isReceipeBuilder) {
      dispatch(fetchIngredients({ page: 1, limit: 100 }));
    }
  }, []);

  useEffect(() => {
    if (selectedValue) {
      setProductData(selectedValue[0]);
      setData(selectedValue[0]);
    }
  }, [selectedValue]);

  useEffect(() => {
    if (error === UNAUTHORIZED) {
      dispatch(authActions.logout());
    }
  }, [error]);

  useEffect(() => {
    if (
      _ingredientsState.value?.data?.length > 0 &&
      newlycreatedingredient &&
      newlycreatedingredient !== '' &&
      newlycreatedingredient !== 'undefined' &&
      newlycreatedingredient !== null &&
      newlycreatedingredient !== undefined
    ) {
      // Add a small delay to ensure Redux store is updated
      setTimeout(() => {
        // Try to find the ingredient by different possible name properties
        const ingredientNameToFind =
          newlycreatedingredient?.ingredientName ||
          newlycreatedingredient?.name ||
          newlycreatedingredient;

        let ing = _ingredientsState.value?.data?.find(
          (item: any) =>
            item?.ingredientName === ingredientNameToFind ||
            item?.name === ingredientNameToFind
        );

        if (ing) {
          setNewlycreatedingredient('');
          setIngredientName(ing);
        } else {
          // If not found in the list yet, but we have a valid ingredient object, set it directly
          if (
            typeof newlycreatedingredient === 'object' &&
            (newlycreatedingredient.ingredientName ||
              newlycreatedingredient.name)
          ) {
            setIngredientName(newlycreatedingredient);
            setNewlycreatedingredient('');
          }
        }
      }, 500); // 500ms delay to allow Redux store to update
    }
  }, [_ingredientsState, newlycreatedingredient]);

  const handleAddButtonClick = () => {
    // if (_.isEmpty(ingredientName?.ingredientName)) {
    //   let msg = `${t('INGREDIENT_NAME')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return;
    // }
    if (!validateField(dispatch, 'INGREDIENT_NAME', ingredientName)) {
      return false;
    }
    // if (_.isEmpty(unitsOfMeasure)) {
    //   let msg = `${t('UNIT_OF_MEASURE')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return;
    // }
    if (!validateField(dispatch, 'UNIT_OF_MEASURE', unitsOfMeasure)) {
      return false;
    }
    // if (_.isEmpty(ingQuantity)) {
    //   let msg = `${t('QUANTITY_PER_UNIT')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return;
    // }

    // if (_.isEmpty(price)) {
    //   let msg = `${t('COST_PRICE')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return;
    // }
    // if (!validateField(dispatch, 'QUANTITY_PER_UNIT', ingQuantity)) {
    //   return false;
    // }
    // if (!validateField(dispatch, 'COST_PRICE', price)) {
    //   return false;
    // }

    if (
      !validateField(
        dispatch,
        'QUANTITY_PER_UNIT',
        ingQuantity,
        Regex.decimalNumber
      )
    ) {
      return false;
    } else {
      let s: any = parseFloat(ingQuantity)?.toFixed(2);
      if (s === '0.00') {
        dispatch(showErrorSnackbar({ message: 'ZERO_QUANTITY_NOT_ALLOWED' }));
        return false;
      }
    }

    if (!validateField(dispatch, 'COST_PRICE', price, Regex.decimalNumber)) {
      return false;
    }

    const totalPrice = (Number(ingQuantity) * Number(price)).toFixed(2);
    const newIngredient = {
      ingredient: ingredientName,
      ingredientId: ingredientName?._id,
      ingredientName: ingredientName?.ingredientName,
      measureType: { measureType: { ...unitsOfMeasure.measureType } },
      // units: Number(ingQuantity),
      // price: Number(price),
      // totalprice: totalPrice,
      units: parseFloat(ingQuantity)?.toFixed(2),
      price: parseFloat(price)?.toFixed(2),
      totalprice: parseFloat(totalPrice)?.toFixed(2),
      isDisabled: true,
      actions: [
        <BakeasyChipEdit
          onClick={() => {
            handleEditClick(ingredientName?._id);
          }}
        />,
        <BakeasyChipDelete
          onClick={(event: any) => {
            event.stopPropagation();
            openDeleteConfirmDialog(ingredientName?._id);
          }}
        />,
      ],
    };
    setIngredientList([...ingredientList, newIngredient]);
    setIngredientName('');
    setUnitsOfMeasure('');
    setIngQuantity('');
    setPrice('');
  };

  const handleDeleteRow = (id: number) => {
    setIngredientList((prevIngredientList) => {
      const index = prevIngredientList.findIndex(
        (ingredient) => ingredient.ingredientId === id
      );
      if (index !== -1) {
        const updatedList = [...prevIngredientList];
        updatedList.splice(index, 1);
        return updatedList;
      } else {
        return prevIngredientList;
      }
    });
  };

  const handleClearForm = () => {
    setIngredientName('');
    setUnitsOfMeasure('');
    setIngQuantity('');
    setPrice('');
  };

  function handleProductTypeChange() {
    setIngredientList([]);
    setRecipeBuilderType('');
    setProductCost('');
    // setSupplierName(_authState?.value?.userDetails?.userInfo?.name);
  }

  function handleRecipeBuilderChange() {
    setIngredientList([]);
    setRecipeBuilderType('');
    setProductCost('');
  }

  const openDeleteConfirmDialog = (id: number) => {
    myContext.setConfirmDialog({
      open: true,
      title: t('CONFIRMATION'),
      message: t('DELETE_ITEM_MESSAGE'),
      onYesClick: () => {
        handleDeleteRow(id);
      },
    });
  };

  function openConfirmDialogMesssageValidation() {
    myContext.setConfirmDialog({
      open: true,
      type: 'confirm-validation-message',
      title: t('CONFIRMATION'),
      message: t(
        'YOU_MUST_COMPLETE_ALL_REQUIRED_FEILDS_OR_CHANGES_WILL_BE_LOST'
      ),
      onNoClick: (event: any) => {},
      onYesClick: (event: any, param: string | undefined) => {
        navigate(-1);
      },
    });
  }

  async function handleCategorySelect(category: any) {
    setSelectedSubCategory(null);
    dispatch(clearSubCategoryState());

    if (category === undefined || category === null) {
      setSelectedCategory(null);
      return;
    }

    setSelectedCategory(category);
    let payload: any = { page: 1, limit: 5, categoryId: category?._id };
    await dispatch(fetchSubCategories(payload));
  }

  const fetchData = async (_id: any) => {
    dispatch(fetchProductById({ id: _id }));
  };

  function openImageDialog(pageName: string, title: string, imgUrl: any) {
    return myContext.setDialog({
      open: true,
      title,
      dialogContent: { pageName, imgUrl, title },
    });
  }

  const handleEditClick = (id: number) => {
    setIngredientList((prevIngredientList) => {
      const index = prevIngredientList.findIndex(
        (ingredient) => ingredient.ingredientId === id
      );
      if (index !== -1) {
        const updatedList = [...prevIngredientList];
        updatedList[index] = { ...updatedList[index], isDisabled: false };
        return updatedList;
      } else {
        return prevIngredientList;
      }
    });
  };

  async function setData(data: any) {
    setProductId(data?.userProductId);
    setProductName(data?.productName);
    setSelectedStatus(data?.status);
    setSelectedProductType(data.productType);
    setSupplierName(
      data?.supplierName ?? _authState?.value?.userDetails?.userInfo?.name
    );

    if (data?.categoryId && data?.categoryName) {
      setSelectedCategory({
        _id: data?.categoryId,
        categoryName: data?.categoryName,
      });
      handleCategorySelect({
        _id: data?.categoryId,
        categoryName: data?.categoryName,
      });
    } else {
      setSelectedCategory(null);
      await dispatch(fetchCategories({ page: 1, limit: 5 }));
    }

    setSelectedSubCategory({
      _id: data?.subCategoryId,
      subCategoryName: data?.subCategoryName,
    });

    setRetailPrice(parseFloat(data?.price)?.toFixed(2));
    setDescription(data.description);
    setSkuNumber(data.productSKU);

    setRecipeBuilder(data.isReceipeBuilder ? 'Yes' : 'No');
    if (data.isReceipeBuilder) {
      dispatch(fetchIngredients({ page: 1, limit: 100 }));
    }

    setRecipeBuilderType(data.receipeBuilderType);

    setSelectedTimeframe(
      data?.minimumDeliveryTime
        ? { timeframe: { ...data?.minimumDeliveryTime } }
        : null
    );

    if (data.productType === 'Manufactured' && data.ingredients) {
      const Ingredients = data.ingredients.map((item: any) => ({
        ingredientId: item.ingredientId,
        ingredientName: item?.ingredientName,
        // units: item.quantity,
        units: parseFloat(item.quantity)?.toFixed(2),
        measureType: { measureType: { ...item.measureType } },
        price: parseFloat(item.price)?.toFixed(2),
        totalPrice: (Number(item.units) * Number(item.price)).toFixed(2),
        isDisabled: true,
        actions: [
          <BakeasyChipEdit
            onClick={() => {
              handleEditClick(item?._id);
            }}
          />,
          <BakeasyChipDelete
            onClick={(event: any) => {
              event.stopPropagation();
              openDeleteConfirmDialog(item?._id);
            }}
          />,
        ],
      }));

      setIngredientList(Ingredients);
    } else {
      setIngredientList([]);
    }

    setSelectedProductImageFile(
      data?.documents?.find((doc: any) => doc?.type === 'productImage')?.fileURL
    );
    setSelectedIngredientImage(
      data?.documents?.find((doc: any) => doc?.type === 'ingredientLabel')
        ?.fileURL
    );
    setSelectedNutritionImage(
      data?.documents?.find((doc: any) => doc?.type === 'nutritionLabel')
        ?.fileURL
    );
    setSelectedSkuImage(
      data?.documents?.find((doc: any) => doc?.type === 'SKUImage')?.fileURL
    );
    setSelectedQrCode(
      data?.documents?.find((doc: any) => doc?.type === 'QRCode')?.fileURL
    );

    setProductCost(parseFloat(data?.productCost)?.toFixed(2));
    setProductNameLabel(data.productName);
  }

  const checkValidity = (): boolean => {
    if (!validateField(dispatch, 'PRODUCT_NAME', productName, formRef)) {
      return false;
    }
    if (
      !validateField(
        dispatch,
        'PRODUCT_ID',
        productId,
        formRef,
        Regex.productId
      )
    ) {
      return false;
    }
    if (
      !validateField(dispatch, 'PRODUCT_TYPE', selectedProductType, formRef)
    ) {
      return false;
    }

    // if (selectedSubCategory) {
    //   if (!validateField(dispatch, 'CATEGORY', selectedCategory)) {
    //     return false;
    //   }
    //   // let msg = `${t("SUBCATEGORY")} ${t("IS_REQUIRED")}`;
    //   // dispatch(showErrorSnackbar({ message: msg }));
    //   // return false;
    // }

    if (!validateField(dispatch, 'RETAIL_PRICE', retailPrice, formRef)) {
      return false;
    } else {
      let s: any = parseFloat(retailPrice)?.toFixed(2);
      if (s === '0.00') {
        dispatch(showErrorSnackbar({ message: 'ZERO_PRICE_NOT_ALLOWED' }));
        return false;
      }
    }

    if (!validateField(dispatch, 'STATUS', selectedStatus, formRef)) {
      return false;
    }

    if (!validateField(dispatch, 'DESCRIPTION', description, formRef)) {
      return false;
    }

    if (selectedProductType === 'Purchased' && recipeBuilder === 'No') {
      if (
        !validateField(dispatch, 'GENERAL_PRODUCT_COST', productCost, formRef)
      ) {
        return false;
      } else {
        let s: any = parseFloat(productCost)?.toFixed(2);
        if (s === '0.00') {
          dispatch(showErrorSnackbar({ message: 'ZERO_PRICE_NOT_ALLOWED' }));
          return false;
        }
      }
    }

    if (selectedProductType === 'Manufactured' && recipeBuilder === 'Yes') {
      if (
        !validateField(
          dispatch,
          'RECIPE_BUILDER_TYPE',
          recipeBuilderType,
          formRef
        )
      ) {
        return false;
      }

      if (!ingredientList.length) {
        let msg = `${t('INGREDIENTS_IS_REQUIRED')}`;
        dispatch(showErrorSnackbar({ message: msg }));
        return false;
      }
    }
    if (selectedProductType === 'Manufactured') {
      if (!validateField(dispatch, 'RECIPE_BUILDER', recipeBuilder, formRef)) {
        return false;
      }

      if (recipeBuilder === 'Yes') {
        if (
          !validateField(
            dispatch,
            'RECIPE_BUILDER_TYPE',
            recipeBuilderType,
            formRef
          )
        ) {
          return false;
        }
      }
    }

    if (!skuNumber) {
      if (!validateField(dispatch, 'SKU_NUMBER', skuNumber, formRef)) {
        return false;
      }
    }

    if (
      ingredientList?.findIndex(
        (item: any, index: number) =>
          parseFloat(item?.units)?.toFixed(2) === '0.00'
      ) >= 0
    ) {
      dispatch(showErrorSnackbar({ message: 'ZERO_QUANTITY_NOT_ALLOWED' }));
      return false;
    }

    // if (
    //   ingredientList?.findIndex(
    //     (item: any, index: number) =>
    //       parseFloat(item?.price)?.toFixed(2) === '0.00'
    //   ) >= 0
    // ) {
    //   dispatch(showErrorSnackbar({ message: 'ZERO_PRICE_NOT_ALLOWED' }));
    //   return false;
    // }
    return true;
  };

  async function onSubmit() {
    if (!checkValidity()) {
      return;
    }

    let productImageUrl,
      ingredientImageUrl,
      nutritionImageUrl,
      skuImageUrl,
      QrImageUrl,
      documentIds: any = productData?.documentIds
        ? [...productData?.documentIds]
        : [];

    if (selectedProductImageFile instanceof File) {
      dispatch(showLoader({ message: t('UPLOADING_PRODUCT_IMAGE') }));
      productImageUrl = await uploadFile(
        selectedProductImageFile,
        'productImage'
      );
      if (productImageUrl?.data?.id) {
        let itemId: any = productData?.documents?.find(
          (item: any) => item.type === 'productImage'
        )?._id;
        if (itemId) {
          let index: any = documentIds.findIndex(
            (item: any) => item === itemId
          );
          if (index === -1) {
            documentIds.push(productImageUrl.data.id);
          } else {
            documentIds.splice(index, 1, productImageUrl.data.id);
          }
        } else {
          documentIds.push(productImageUrl.data.id);
        }
      }
      dispatch(hideLoader());
    }

    if (selectedIngredientImage instanceof File) {
      dispatch(showLoader({ message: t('UPLOADING_INGREDIENT_LABEL_IMAGE') }));
      ingredientImageUrl = await uploadFile(
        selectedIngredientImage,
        'ingredientLabel'
      );
      if (ingredientImageUrl?.data?.id) {
        let itemId: any = productData?.documents?.find(
          (item: any) => item.type === 'ingredientLabel'
        )?._id;
        if (itemId) {
          let index: any = documentIds.findIndex(
            (item: any) => item === itemId
          );
          if (index === -1) {
            documentIds.push(ingredientImageUrl.data.id);
          } else {
            documentIds.splice(index, 1, ingredientImageUrl.data.id);
          }
        } else {
          documentIds.push(ingredientImageUrl.data.id);
        }
      }
      dispatch(hideLoader());
    }

    if (selectedNutritionImage instanceof File) {
      dispatch(showLoader({ message: t('UPLOADING_NUTRITION_LABEL_IMAGE') }));
      nutritionImageUrl = await uploadFile(
        selectedNutritionImage,
        'nutritionLabel'
      );
      if (nutritionImageUrl?.data?.id) {
        let itemId: any = productData?.documents?.find(
          (item: any) => item.type === 'nutritionLabel'
        )?._id;
        if (itemId) {
          let index: any = documentIds.findIndex(
            (item: any) => item === itemId
          );
          if (index === -1) {
            documentIds.push(nutritionImageUrl.data.id);
          } else {
            documentIds.splice(index, 1, nutritionImageUrl.data.id);
          }
        } else {
          documentIds.push(nutritionImageUrl.data.id);
        }
      }
      dispatch(hideLoader());
    }

    if (skuImage instanceof File) {
      dispatch(showLoader({ message: t('UPLOADING_SKU_IMAGE') }));
      skuImageUrl = await uploadFile(skuImage, 'SKUImage');
      if (skuImageUrl?.data?.id) {
        let itemId: any = productData?.documents?.find(
          (item: any) => item.type === 'SKUImage'
        )?._id;
        if (itemId) {
          let index: any = documentIds.findIndex(
            (item: any) => item === itemId
          );
          if (index === -1) {
            documentIds.push(skuImageUrl.data.id);
          } else {
            documentIds.splice(index, 1, skuImageUrl.data.id);
          }
        } else {
          documentIds.push(skuImageUrl.data.id);
        }
      }
      dispatch(hideLoader());
    }

    if (qrCode instanceof File) {
      dispatch(showLoader({ message: t('UPLOADING_QR_CODE_IMAGE') }));
      QrImageUrl = await uploadFile(qrCode, 'QRCode');
      if (QrImageUrl?.data?.id) {
        let itemId: any = productData?.documents?.find(
          (item: any) => item.type === 'QRCode'
        )?._id;
        if (itemId) {
          let index: any = documentIds.findIndex(
            (item: any) => item === itemId
          );
          if (index === -1) {
            documentIds.push(QrImageUrl.data.id);
          } else {
            documentIds.splice(index, 1, QrImageUrl.data.id);
          }
        } else {
          documentIds.push(QrImageUrl.data.id);
        }
      }
      dispatch(hideLoader());
    }

    let payload: any = {
      productName: productName,
      userProductId: productId,
      supplierName: supplierName,
      productType: selectedProductType,
      categoryId: selectedCategory?._id ?? null,
      subCategoryId: selectedSubCategory?._id ?? null,
      price: parseFloat(retailPrice)?.toFixed(2),
      status:
        selectedStatus === 'Temp. Unavailable' ? 'Unavailable' : selectedStatus,
      description: description,
      productSKU: skuNumber,
      minimumDeliveryTime: selectedTimeframe?.timeframe,
    };

    if (documentIds?.length > 0) {
      payload.documentIds = documentIds;
    }

    if (selectedProductType === 'Purchased') {
      payload.productCost = parseInt(productCost);
    }

    if (selectedProductType === 'Manufactured') {
      payload.isReceipeBuilder = recipeBuilder === 'Yes' ? true : false;
      if (recipeBuilder === 'Yes') {
        payload.receipeBuilderType = recipeBuilderType;
        payload.ingredients = ingredientList.map((item: any) => ({
          ingredientId: item.ingredientId,
          quantity: item.units,
          measureType: item.measureType?.measureType,
          price: item.price,
        }));
      }
    }

    if (selectedProductType === 'Purchased') {
      payload.isReceipeBuilder = false;
    }

    if (isDuplicate) {
      if (productName === productNameLabel) {
        const msg = t('PRODUCT_NAME_CANNOT_SAME');
        dispatch(showErrorSnackbar({ message: msg }));
        return;
      } else {
        let response: any = await dispatch(addProduct(payload));
        if (response?.payload?.status === 200) {
          dispatch(clearProductState());
          navigate(-1);
        }
        return;
      }
    }

    if (isEdit) {
      let newPayload = { ...payload, id: location?.state?._id };
      let response: any = await dispatch(modifyProduct(newPayload));
      if (response?.payload?.status === 200) {
        dispatch(clearProductState());
        navigate(-1);
      }
    } else {
      let response: any = await dispatch(addProduct(payload));
      if (response?.payload?.status === 200) {
        dispatch(clearProductState());
        navigate(-1);
      }
    }
  }

  function handleCheckQuantityChange(row: any) {
    let filteredRowIndex1 = ingredientList.findIndex(
      (tableRow: any) => tableRow.ingredientId === row?.ingredientId
    );
    if (filteredRowIndex1 >= 0) {
      let a = ingredientList;
      a[filteredRowIndex1] = row;
      setIngredientList([...a]);
    }
  }

  const handleQuantityChange = (row: any, value: any) => {
    let s: any = parseFloat(value)?.toFixed(2);
    if (s === '0.00') {
      dispatch(showErrorSnackbar({ message: 'ZERO_PRICE_NOT_ALLOWED' }));
    }
    handleCheckQuantityChange(row);
  };

  function getMenus() {
    return (
      <Grid>
        {isView && (
          <div className="tableOptions">
            <Button.Edit
              onClick={(event: any) => {
                setIsEdit(true);
                setIsView(false);
              }}
            />

            <BakeasyButtonPrint
              onClick={function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): void {
                dispatch(
                  downloadProductDetails({
                    id: location?.state?._id,
                    downloadType: 'pdf',
                  })
                );
              }}
            />

            {/* <BakeasyButtonExport
              onClick={function(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
                dispatch(downloadProductDetails({ id: location?.state?._id, downloadType: 'csv' }));
              }}
            /> */}

            <BakeasyButtonDuplicate
              onClick={(event: any) => {
                setIsView(false);
                setIsDuplicate(true);
              }}
            />
          </div>
        )}
      </Grid>
    );
  }

  const openAddIngredientDialog = (props: any) => {
    myContext.setDialog({
      open: true,
      title: 'ADD_INGREDIENT',
      dialogContent: {
        pageName: 'AddIngredient',
        params: props,
        onBack: async (newIngredient: any) => {
          if (
            newIngredient &&
            newIngredient !== 'undefined' &&
            newIngredient !== null &&
            typeof newIngredient === 'object' &&
            (newIngredient?.ingredientName || newIngredient?.name)
          ) {
            // Ensure the ingredient has the correct structure
            const normalizedIngredient = {
              ...newIngredient,
              ingredientName:
                newIngredient.ingredientName || newIngredient.name,
            };

            // Set the newly created ingredient to trigger the useEffect
            setNewlycreatedingredient(normalizedIngredient);

            // Refresh the ingredients list to include the new ingredient
            dispatch(fetchIngredients({ page: 1, limit: 100 }));

            // Don't set ingredientName immediately - let useEffect handle it after Redux updates
          } else if (
            newIngredient === 'undefined' ||
            newIngredient === null ||
            newIngredient === undefined
          ) {
            // Explicitly clear the ingredient if dialog returns undefined/null
            setNewlycreatedingredient('');
            // Don't change ingredientName, keep current value
          }
        },
      },
    });
  };

  function createProductUI() {
    return (
      <div ref={formRef}>
        <Grid>
          <Grid item>
            <BakeasyAppBar
              title={t(
                isEdit
                  ? 'EDIT_PRODUCT'
                  : isView
                    ? 'PRODUCT_DETAILS'
                    : 'ADD_PRODUCT'
              )}
              onBackClick={() => {
                openConfirmDialogMesssageValidation();
              }}
              menus={getMenus()}
            />
          </Grid>
          <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
            <Grid container>
              <BakeasyHeaderLabel message={'PRODUCT_DETAILS'} />
            </Grid>

            <Grid container spacing={2} pl={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyAutoCompleteProductName
                  disabled={isView}
                  value={productName}
                  options={_productState?.productNames}
                  placeholder={t('SELECT_PRODUCT_NAME')}
                  onChange={async (newValue: any) => {
                    setProductName(newValue);
                    if (
                      typeof newValue === 'string' &&
                      newValue?.length === 0
                    ) {
                      await dispatch(fetchProductNames({ limit: 5 }));
                    } else if (
                      typeof newValue === 'string' &&
                      newValue?.length > 2
                    ) {
                      dispatch(
                        fetchProductNames({ limit: 5, search: newValue })
                      );
                    }
                  }}
                />
                {/* <TextField.ProductName
								disabled={isView}
								value={productName}
								onChange={(event: any) => {
									setProductName(event.target.value);
								}}
							/> */}
                {!isView && productNameLabel && (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ mt: 1 }}
                  >
                    Product Name: {productNameLabel}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.ProductId
                  disabled={isView}
                  value={productId}
                  placeHolder={t('ENTER_PRODUCT_ID')}
                  onChange={(event: any) => {
                    setProductId(event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Dropdown.SelectProductType
                  disabled={isView}
                  value={selectedProductType}
                  required={true}
                  onChange={(event: any) => {
                    setSelectedProductType(event.target.value);
                    handleProductTypeChange();
                    if (event.target.value === 'Purchased') {
                      setRecipeBuilder('No');
                    } else if (event.target.value === 'Manufactured') {
                      setRecipeBuilder('Yes');
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Dropdown.SelectRecipeBuilder
                  disabled={
                    isView ||
                    selectedProductType === 'Purchased' ||
                    !_authState?.value?.userDetails?.userInfo?.isReceipeBuilder
                  }
                  tooltipTitle={
                    !_authState?.value?.userDetails?.userInfo?.isReceipeBuilder
                      ? t('CONTACT_BAKEASY')
                      : ''
                  }
                  value={recipeBuilder}
                  required={true}
                  onChange={(event: any) => {
                    handleRecipeBuilderChange();
                    setRecipeBuilder(event.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyAutoCompleteCategoryA
                  disabled={isView}
                  value={selectedCategory}
                  options={_categoryState.value?.data}
                  onChange={(newValue: any) => {
                    if (
                      typeof newValue === 'string' &&
                      newValue?.length === 0
                    ) {
                      dispatch(fetchCategories({ page: 1, limit: 5 }));
                    }

                    if (typeof newValue === 'string' && newValue?.length > 2) {
                      dispatch(
                        fetchCategories({ page: 1, limit: 5, search: newValue })
                      );
                    }

                    if (typeof newValue === 'object') {
                      handleCategorySelect(newValue);
                    }

                    if (newValue === null) {
                      setSelectedCategory(null);
                      dispatch(fetchCategories({ page: 1, limit: 5 }));
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyAutoCompleteSubCategoryA
                  disabled={
                    isView || selectedCategory === null
                    //|| _subCategoryState?.value?.data?.length === 0
                  }
                  value={selectedSubCategory}
                  options={_subCategoryState.value?.data}
                  onChange={async (newValue: any) => {
                    if (
                      typeof newValue === 'string' &&
                      newValue?.length === 0
                    ) {
                      if (selectedCategory) {
                        let payload: any = {
                          page: 1,
                          limit: 5,
                          categoryId: selectedCategory?._id,
                        };
                        await dispatch(fetchSubCategories(payload));
                      }
                    }

                    if (typeof newValue === 'string' && newValue?.length > 2) {
                      if (selectedCategory) {
                        let payload: any = {
                          page: 1,
                          limit: 5,
                          categoryId: selectedCategory?._id,
                          search: newValue,
                        };
                        await dispatch(fetchSubCategories(payload));
                      }
                    }

                    if (typeof newValue === 'object') {
                      setSelectedSubCategory(newValue);
                    }
                    if (newValue === null) {
                      setSelectedSubCategory(null);
                    }
                  }}
                />
              </Grid>

              {recipeBuilder === 'Yes' && (
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <Dropdown.RecipeBuilderType
                    value={recipeBuilderType}
                    required={true}
                    onChange={(event: any) => {
                      setRecipeBuilderType(event.target.value);
                    }}
                  />
                </Grid>
              )}

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.RetailPrice
                  disabled={isView}
                  value={retailPrice}
                  onChange={(event: any) => {
                    setRetailPrice(event.target.value);
                  }}
                  placeHolder={t('ENTER_RETAIL_PRICE')}
                  regexPattern={RegExp('^[0-9.]*$')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                {/* <Dropdown.DeliveryTimeframe
                disabled={isView}
                value={selectedTimeframe}
                onChange={(event: any) => {
                  setSelectedTimeframe(event.target.value);
                }}
              /> */}
                <BakeasyAutoDeliveryTimeframe
                  label={t('MINIMUM_DELIVERY_TIMEFRAME')}
                  required={false}
                  value={selectedTimeframe}
                  options={_dropdownDataState.value?.data?.DeliveryTimeframe}
                  onChange={async (newValue: any) => {
                    if (typeof newValue === 'object') {
                      setSelectedTimeframe(newValue);
                    }
                    if (newValue === null) {
                      setSelectedTimeframe(null);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Dropdown.Status
                  disabled={isView}
                  required={true}
                  value={selectedStatus}
                  options={PRODUCT_STATUS_ARRAY}
                  onChange={(event: any) => {
                    setSelectedStatus(event.target.value);
                  }}
                />
              </Grid>

              {selectedProductType === 'Purchased' && (
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Name
                    disabled={isView}
                    label={t('SUPPLIER_NAME')}
                    value={supplierName}
                    onChange={(event: any) => {
                      setSupplierName(event.target.value);
                    }}
                  />
                </Grid>
              )}

              {recipeBuilder === 'No' &&
                selectedProductType !== 'Manufactured' && (
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField.GeneralProductCost
                      disabled={isView}
                      value={productCost}
                      onChange={(event: any) => {
                        setProductCost(event.target.value);
                      }}
                      regexPattern={RegExp('^[0-9,.]*$')}
                    />
                  </Grid>
                )}

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  disabled={isView}
                  label={t('SKU_NUMBER')}
                  fullWidth={true}
                  required={true}
                  type="text"
                  name="skuNumber"
                  value={skuNumber}
                  placeHolder={t('ENTER_SKU_NUMBER')}
                  onChange={(event: any) => {
                    setSkuNumber(event.target.value);
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mt: 0.2 }} pl={2}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <TextField.Description
                  required={true}
                  disabled={isView}
                  value={description}
                  rows={6}
                  onChange={(event: any) => {
                    setDescription(event.target.value);
                  }}
                  placeHolder={t('ENTER_DESCRIPTION')}
                />
              </Grid>
              {/* conditions for new */}

              {!isEdit && !isView && location?.state.isNew && (
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BakeasyImgSelector
                    uploadState={'initial'}
                    id="productImage"
                    value={selectedProductImageFile}
                    label={t('PRODUCT_IMAGE')}
                    name="productImage"
                    headerText={t('ACCEPTED_FORMATS')}
                    footerText={t('PLEASE_UPLOAD')}
                    onChange={(file: any) => {
                      setSelectedProductImageFile(file);
                    }}
                  />
                </Grid>
              )}

              {/* conditions if not logo present through edit and view */}
              {(!isEdit && !isView) ||
                //(isEdit && !selectedProductImageFile && (
                (isEdit &&
                  !productData?.documents?.find(
                    (doc: any) => doc?.type === 'productImage'
                  )?.fileURL && (
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <BakeasyImgSelector
                        uploadState={'initial'}
                        id="productImage"
                        value={selectedProductImageFile}
                        label={t('PRODUCT_IMAGE')}
                        name="productImage"
                        headerText={t('ACCEPTED_FORMATS')}
                        footerText={t('PLEASE_UPLOAD')}
                        onChange={(file: any) => {
                          setSelectedProductImageFile(file);
                        }}
                      />
                    </Grid>
                  ))}

              {/* conditions if logo present */}
              {
                //(isEdit || isView) && selectedProductImageFile && (
                (isEdit || isView) &&
                  productData?.documents?.find(
                    (doc: any) => doc?.type === 'productImage'
                  )?.fileURL && (
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <BakeasyImgSelector
                        disabled={isView}
                        uploadState={'initFromProps'}
                        id="productImage"
                        value={
                          productData?.documents?.find(
                            (doc: any) => doc?.type === 'productImage'
                          )?.fileURL
                        }
                        label={t('PRODUCT_IMAGE')}
                        name="productImage"
                        headerText={t('ACCEPTED_FORMATS')}
                        footerText={t('PLEASE_UPLOAD')}
                        onChange={(file: any) => {
                          setSelectedProductImageFile(file);
                        }}
                        onClick={() => {
                          openImageDialog(
                            'ViewImage',
                            t('PRODUCT_IMAGE'),
                            productData?.documents?.find(
                              (doc: any) => doc?.type === 'productImage'
                            )?.fileURL
                          );
                        }}
                      />
                    </Grid>
                  )
              }
            </Grid>

            <BakeasyDivider />

            {selectedProductType === 'Manufactured' &&
              recipeBuilder === 'Yes' && (
                <>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <BakeasyHeaderLabel
                      message={t('RECIPE_BUILDER_INGREDIENTS')}
                    />
                  </Grid>

                  <Grid container spacing={2} sx={{ display: 'flex', pl: 2 }}>
                    <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                      <BakeasyAutoCompleteIngredient
                        disabled={isView || recipeBuilder === 'No'}
                        value={ingredientName}
                        options={
                          _ingredientsState.value?.data?.length > 0
                            ? _ingredientsState.value?.data
                            : null
                        }
                        onAddClick={(props: any) => {
                          setNewlycreatedingredient('');
                          openAddIngredientDialog(props);
                        }}
                        onChange={async (newValue: any) => {
                          if (
                            typeof newValue === 'string' &&
                            newValue.length > 1
                          ) {
                            dispatch(
                              fetchIngredients({
                                page: 1,
                                limit: 100,
                                search: newValue,
                              })
                            );
                          }

                          if (
                            typeof newValue === 'string' &&
                            newValue.length === 0
                          ) {
                            dispatch(fetchIngredients({ page: 1, limit: 100 }));
                          }

                          if (
                            typeof newValue === 'object' &&
                            newValue?.id !== 0 &&
                            newValue?.ingredientName &&
                            newValue !== undefined &&
                            newValue !== null
                          ) {
                            setIngredientName(newValue);
                          } else if (
                            newValue === undefined ||
                            newValue === null
                          ) {
                            // Don't set undefined values
                            setIngredientName('');
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                      {/* <BakeasySelectLabel
                    fullWidth={true}
                    disabled={isView || recipeBuilder === 'No'}
                    label={t('UNIT_OF_MEASURE')}
                    statusOptions={unitsOfMeasureOptions}
                    placeholder="Select unit of measure"
                    size="small"
                    value={unitsOfMeasure}
                    onChange={(event: any) => setUnitsOfMeasure(event.target.value)}
                  /> */}
                      <BakeasyAutoUnitOfMeasure
                        required={false}
                        disabled={isView || recipeBuilder === 'No'}
                        value={unitsOfMeasure}
                        options={_dropdownDataState.value?.data?.UnitOfMeasure}
                        onChange={async (newValue: any) => {
                          if (typeof newValue === 'object') {
                            setUnitsOfMeasure(newValue);
                          }
                          if (newValue === null) {
                            setUnitsOfMeasure(null);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                      <BakeasyTextField
                        label={t('QUANTITY_PER_UNIT')}
                        disabled={isView || recipeBuilder === 'No'}
                        type="text"
                        placeHolder={t('ENTER_QUANTITY_PER_UNIT')}
                        name="ingQuantity"
                        fullWidth={true}
                        maxLength={5}
                        value={ingQuantity}
                        onChange={(event: any) => {
                          setIngQuantity(
                            prepareDemicalNumber(event.target.value)
                          );
                        }}
                        regexPattern={Regex.decimalNumber}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                      <BakeasyTextField
                        label={t('COST_PRICE')}
                        disabled={isView || recipeBuilder === 'No'}
                        type="text"
                        placeHolder={t('ENTER_COST_PRICE')}
                        name="price"
                        value={price}
                        fullWidth={true}
                        onChange={(event: any) => {
                          setPrice(prepareDemicalNumber(event.target.value));
                        }}
                        regexPattern={Regex.decimalNumber}
                      />
                    </Grid>
                  </Grid>
                  {selectedProductType === 'Manufactured' &&
                    recipeBuilder === 'Yes' && (
                      <>
                        <Grid
                          container
                          sx={{ alignItems: 'end', justifyContent: 'end' }}
                        >
                          <Grid
                            item
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Grid m={1}>
                              <BakeasyButtonClear onClick={handleClearForm} />
                            </Grid>
                            <Grid my={1}>
                              <BakeasyButtonAdd
                                onClick={() => {
                                  const sameIngredient = ingredientList.some(
                                    (ingredient) =>
                                      ingredient?.ingredientName?.toLowerCase() ===
                                      ingredientName?.ingredientName?.toLowerCase()
                                  );

                                  if (sameIngredient) {
                                    dispatch(
                                      showErrorSnackbar({
                                        message: t(
                                          'INGREDIENTS_ALLREADY_ADDED'
                                        ),
                                      })
                                    );
                                    return;
                                  }
                                  handleAddButtonClick();
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid container pl={2}>
                          {ingredientList?.length > 0 ? (
                            <BakeasySimpleTable
                              headers={ingredientTableHeaders}
                              tableData={ingredientList}
                              handleIngredientQuantityChanged={
                                handleQuantityChange
                              }
                              handleIngredientPriceChanged={
                                handleQuantityChange
                              }
                              handleIngredientQuantityEditChanged={
                                handleQuantityChange
                              }
                              handleIngredientMeasureTypeChanged={
                                handleQuantityChange
                              }
                            />
                          ) : (
                            <BakeasyEmptyMsg message={t('NO_DATA_FOUND')} />
                          )}
                        </Grid>
                      </>
                    )}
                  <BakeasyDivider />
                </>
              )}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('OTHER_DETAILS')} />
              <Grid sx={{ marginTop: 0.5, marginLeft: 1 }}>
                <ImageUploadMessage />
              </Grid>
            </Grid>
            <Grid
              container
              sx={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Grid item>
                {/* conditions for new */}
                {!isEdit && !isView && location?.state.isNew && (
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <BakeasyImgSelector
                      uploadState={'initial'}
                      id="ingredientImage"
                      value={selectedIngredientImage}
                      label={t('INGREDIENT_IMAGE')}
                      name="ingredientImage"
                      headerText={t('ACCEPTED_FORMATS')}
                      footerText={t('PLEASE_UPLOAD')}
                      onChange={(file: any) => {
                        setSelectedIngredientImage(file);
                      }}
                    />
                  </Grid>
                )}
              </Grid>

              <Grid item>
                {/* conditions if not logo present through edit and view */}
                {(!isEdit && !isView) ||
                  (isEdit &&
                    !productData?.documents?.find(
                      (doc: any) => doc?.type === 'ingredientLabel'
                    )?.fileURL && (
                      <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <BakeasyImgSelector
                          uploadState={'initial'}
                          id="ingredientImage"
                          value={selectedIngredientImage}
                          label={t('INGREDIENT_IMAGE')}
                          name="ingredientImage"
                          headerText={t('ACCEPTED_FORMATS')}
                          footerText={t('PLEASE_UPLOAD')}
                          onChange={(file: any) => {
                            setSelectedIngredientImage(file);
                          }}
                        />
                      </Grid>
                    ))}
              </Grid>

              <Grid item>
                {/* conditions if logo present */}
                {(isEdit || isView) &&
                  productData?.documents?.find(
                    (doc: any) => doc?.type === 'ingredientLabel'
                  )?.fileURL && (
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <BakeasyImgSelector
                        disabled={isView}
                        uploadState={'initFromProps'}
                        id="ingredientImage"
                        value={
                          productData?.documents?.find(
                            (doc: any) => doc?.type === 'ingredientLabel'
                          )?.fileURL
                        }
                        label={t('INGREDIENT_IMAGE')}
                        name="ingredientImage"
                        headerText={t('ACCEPTED_FORMATS')}
                        footerText={t('PLEASE_UPLOAD')}
                        onChange={(file: any) => {
                          setSelectedIngredientImage(file);
                        }}
                        onClick={() =>
                          openImageDialog(
                            'ViewImage',
                            t('INGREDIENT_IMAGE'),
                            productData?.documents?.find(
                              (doc: any) => doc?.type === 'ingredientLabel'
                            )?.fileURL
                          )
                        }
                      />
                    </Grid>
                  )}
              </Grid>

              <Grid item>
                {/* conditions for new */}
                {!isEdit && !isView && location?.state.isNew && (
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <BakeasyImgSelector
                      uploadState={'initial'}
                      id="nutritionImage"
                      value={selectedNutritionImage}
                      label={t('NUTRITION_IMAGE')}
                      name="nutritionImage"
                      headerText={t('ACCEPTED_FORMATS')}
                      footerText={t('PLEASE_UPLOAD')}
                      onChange={(file: any) => {
                        setSelectedNutritionImage(file);
                      }}
                    />
                  </Grid>
                )}
              </Grid>

              <Grid item>
                {/* conditions if not logo present through edit and view */}
                {(!isEdit && !isView) ||
                  (isEdit &&
                    !productData?.documents?.find(
                      (doc: any) => doc?.type === 'nutritionLabel'
                    )?.fileURL && (
                      <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <BakeasyImgSelector
                          uploadState={'initial'}
                          id="nutritionImage"
                          value={selectedNutritionImage}
                          label={t('NUTRITION_IMAGE')}
                          name="nutritionImage"
                          headerText={t('ACCEPTED_FORMATS')}
                          footerText={t('PLEASE_UPLOAD')}
                          onChange={(file: any) => {
                            setSelectedNutritionImage(file);
                          }}
                        />
                      </Grid>
                    ))}
              </Grid>

              <Grid item>
                {/* conditions if logo present */}
                {(isEdit || isView) &&
                  productData?.documents?.find(
                    (doc: any) => doc?.type === 'nutritionLabel'
                  )?.fileURL && (
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <BakeasyImgSelector
                        disabled={isView}
                        uploadState={'initFromProps'}
                        id="nutritionImage"
                        value={
                          productData?.documents?.find(
                            (doc: any) => doc?.type === 'nutritionLabel'
                          )?.fileURL
                        }
                        label={t('NUTRITION_IMAGE')}
                        name="nutritionImage"
                        headerText={t('ACCEPTED_FORMATS')}
                        footerText={t('PLEASE_UPLOAD')}
                        onChange={(file: any) => {
                          setSelectedNutritionImage(file);
                        }}
                        onClick={() =>
                          openImageDialog(
                            'ViewImage',
                            t('NUTRITION_IMAGE'),
                            productData?.documents?.find(
                              (doc: any) => doc?.type === 'nutritionLabel'
                            )?.fileURL
                          )
                        }
                      />
                    </Grid>
                  )}
              </Grid>

              {/* <Grid item>
              <>
                <BakeasyTextField
                  disabled={isView}
                  label={t('SKU_NUMBER')}
                  fullWidth={false}
                  required={true}
                  type="text"
                  name="skuNumber"
                  value={skuNumber}
                  placeHolder={t('ENTER_SKU_NUMBER')}
                  onChange={(event: any) => {
                    setSkuNumber(event.target.value);
                  }}
                /> */}

              <Grid item>
                {/* conditions for new */}
                {!isEdit && !isView && location?.state.isNew && (
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <BakeasyImgSelector
                      uploadState={'initial'}
                      id="skuImage"
                      value={skuImage}
                      label={t('SKU_IMAGE')}
                      name="skuImage"
                      headerText={t('ACCEPTED_FORMATS')}
                      footerText={t('PLEASE_UPLOAD')}
                      onChange={(file: any) => {
                        setSelectedSkuImage(file);
                      }}
                    />
                  </Grid>
                )}
              </Grid>

              <Grid item>
                {/* conditions if not logo present through edit and view */}
                {(!isEdit && !isView) ||
                  (isEdit &&
                    !productData?.documents?.find(
                      (doc: any) => doc?.type === 'SKUImage'
                    )?.fileURL && (
                      <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <BakeasyImgSelector
                          uploadState={'initial'}
                          id="skuImage"
                          value={skuImage}
                          label={t('SKU_IMAGE')}
                          name="skuImage"
                          headerText={t('ACCEPTED_FORMATS')}
                          footerText={t('PLEASE_UPLOAD')}
                          onChange={(file: any) => {
                            setSelectedSkuImage(file);
                          }}
                        />
                      </Grid>
                    ))}
              </Grid>

              <Grid item>
                {/* conditions if logo present */}
                {(isEdit || isView) &&
                  productData?.documents?.find(
                    (doc: any) => doc?.type === 'SKUImage'
                  )?.fileURL && (
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <BakeasyImgSelector
                        disabled={isView}
                        uploadState={'initFromProps'}
                        id="skuImage"
                        value={
                          productData?.documents?.find(
                            (doc: any) => doc?.type === 'SKUImage'
                          )?.fileURL
                        }
                        label={t('SKU_IMAGE')}
                        name="skuImage"
                        headerText={t('ACCEPTED_FORMATS')}
                        footerText={t('PLEASE_UPLOAD')}
                        onChange={(file: any) => {
                          setSelectedSkuImage(file);
                        }}
                        onClick={() =>
                          openImageDialog(
                            'ViewImage',
                            t('SKU_IMAGE'),
                            productData?.documents?.find(
                              (doc: any) => doc?.type === 'SKUImage'
                            )?.fileURL
                          )
                        }
                      />
                    </Grid>
                  )}
              </Grid>
              {/* </>
            </Grid> */}

              <Grid item>
                {/* conditions for new */}
                {!isEdit && !isView && location?.state.isNew && (
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <BakeasyImgSelector
                      uploadState={'initial'}
                      id="qrCode"
                      value={qrCode}
                      label={t('QR_CODE')}
                      name="qrCode"
                      headerText={t('ACCEPTED_FORMATS')}
                      footerText={t('PLEASE_UPLOAD')}
                      onChange={(file: any) => {
                        setSelectedQrCode(file);
                      }}
                    />
                  </Grid>
                )}
              </Grid>

              <Grid item>
                {/* conditions if not logo present through edit and view */}
                {(!isEdit && !isView) ||
                  (isEdit &&
                    !productData?.documents?.find(
                      (doc: any) => doc?.type === 'QRCode'
                    )?.fileURL && (
                      <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <BakeasyImgSelector
                          uploadState={'initial'}
                          id="qrCode"
                          value={qrCode}
                          label={t('QR_CODE')}
                          name="qrCode"
                          headerText={t('ACCEPTED_FORMATS')}
                          footerText={t('PLEASE_UPLOAD')}
                          onChange={(file: any) => {
                            setSelectedQrCode(file);
                          }}
                        />
                      </Grid>
                    ))}
              </Grid>

              <Grid item>
                {/* conditions if logo present */}
                {(isEdit || isView) &&
                  productData?.documents?.find(
                    (doc: any) => doc?.type === 'QRCode'
                  )?.fileURL && (
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <BakeasyImgSelector
                        disabled={isView}
                        uploadState={'initFromProps'}
                        id="qrCode"
                        value={
                          productData?.documents?.find(
                            (doc: any) => doc?.type === 'QRCode'
                          )?.fileURL
                        }
                        label={t('QR_CODE')}
                        name="qrCode"
                        headerText={t('ACCEPTED_FORMATS')}
                        footerText={t('PLEASE_UPLOAD')}
                        onChange={(file: any) => {
                          setSelectedQrCode(file);
                        }}
                        onClick={() =>
                          openImageDialog(
                            'ViewImage',
                            t('QR_CODE'),
                            productData?.documents?.find(
                              (doc: any) => doc?.type === 'QRCode'
                            )?.fileURL
                          )
                        }
                      />
                    </Grid>
                  )}
              </Grid>
            </Grid>

            <Grid
              item
              sx={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Grid container sx={{ alignItems: 'end', justifyContent: 'end' }}>
                {!isView && (
                  <Grid margin={1}>
                    <BakeasyButtonCancel
                      onClick={function (
                        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                      ): void {
                        openConfirmDialogMesssageValidation();
                      }}
                    />
                  </Grid>
                )}

                <Grid my={1}>
                  {!isView && isEdit && (
                    <BakeasyButtonUpdate
                      onClick={function (
                        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                      ): void {
                        onSubmit();
                      }}
                    />
                  )}
                  {!isView && !isEdit && (
                    <BakeasyButtonCreate
                      onClick={function (
                        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                      ): void {
                        onSubmit();
                      }}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </div>
    );
  }

  function viewProductUI() {
    return (
      <Grid>
        <Grid item>
          <BakeasyAppBar
            title={t(
              isEdit
                ? 'EDIT_PRODUCT'
                : isView
                  ? 'PRODUCT_DETAILS'
                  : 'ADD_PRODUCT'
            )}
            onBackClick={() => {
              navigate(-1);
            }}
            menus={getMenus()}
          />
        </Grid>
        <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
          <Grid container>
            <BakeasyHeaderLabel message={'PRODUCT_DETAILS'} />
          </Grid>

          <Grid container spacing={2} pl={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('PRODUCT_NAME')} value={productName} />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('PRODUCT_ID')} value={productId} />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('PRODUCT_TYPE')}
                // value={selectedProductType}
                value={
                  selectedProductType
                    ? t(
                        `${selectedProductType?.toUpperCase().replace(/\s+/g, '_')}`
                      )
                    : selectedProductType
                }
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('RECIPE_BUILDER')}
                // value={recipeBuilder}
                value={
                  recipeBuilder
                    ? t(`${recipeBuilder?.toUpperCase().replace(/\s+/g, '_')}`)
                    : recipeBuilder
                }
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('CATEGORY')}
                value={selectedCategory?.categoryName}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('SUBCATEGORY')}
                value={selectedSubCategory?.subCategoryName}
              />
            </Grid>

            {recipeBuilder === 'Yes' && (
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('RECIPE_BUILDER_TYPE')}
                  value={recipeBuilderType}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('RETAIL_PRICE') + getCurrency(_userProfile?.value)}
                value={retailPrice}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('MINIMUM_DELIVERY_TIMEFRAME')}
                value={
                  selectedTimeframe?.timeframe
                    ? selectedTimeframe?.timeframe[i18n.language]
                    : ''
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('STATUS')}
                value={
                  //selectedStatus ? selectedStatus[i18n.language] : ''

                  selectedStatus
                    ? t(`${selectedStatus?.toUpperCase().replace(/\s+/g, '_')}`)
                    : selectedStatus
                }
              />
            </Grid>

            {skuNumber && (
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('SKU_NUMBER')} value={skuNumber} />
              </Grid>
            )}

            {selectedProductType === 'Purchased' && (
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('SUPPLIER_NAME')}
                  value={supplierName}
                />
              </Grid>
            )}

            {recipeBuilder === 'No' &&
              selectedProductType !== 'Manufactured' && (
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <BakeasyLabelText
                    label={
                      t('GENERAL_PRODUCT_COST') +
                      getCurrency(_userProfile?.value)
                    }
                    value={productCost}
                  />
                </Grid>
              )}

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('DESCRIPTION')} value={description} />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mt: 0.2 }} pl={2}>
            {selectedProductImageFile && (
              <Grid item>
                <BakeasyImgSelectorView
                  uploadState="initFromProps"
                  disabled={true}
                  id="productImage"
                  value={selectedProductImageFile}
                  label={t('PRODUCT_IMAGE')}
                  name="productImage"
                  headerText={t('ACCEPTED_FORMATS')}
                  footerText={t('PLEASE_UPLOAD')}
                  onClick={() =>
                    openImageDialog(
                      'ViewImage',
                      t('PRODUCT_IMAGE'),
                      selectedProductImageFile
                    )
                  }
                />
              </Grid>
            )}
          </Grid>

          <BakeasyDivider />

          {selectedProductType === 'Manufactured' &&
            recipeBuilder === 'Yes' && (
              <>
                <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
                  <BakeasyHeaderLabel
                    message={t('RECIPE_BUILDER_INGREDIENTS')}
                  />
                </Grid>

                <Grid container pl={2}>
                  {ingredientList?.length > 0 ? (
                    <BakeasySimpleTable
                      headers={ingredientTableHeadersForView}
                      tableData={ingredientList}
                    />
                  ) : (
                    <BakeasyEmptyMsg message={t('NO_DATA_FOUND')} />
                  )}
                </Grid>
              </>
            )}
          <BakeasyDivider />
          <Grid container spacing={2} sx={{ pl: 2 }}>
            {selectedIngredientImage && (
              <Grid item>
                <BakeasyImgSelectorView
                  uploadState="initFromProps"
                  disabled={true}
                  id="ingredientImage"
                  value={selectedIngredientImage}
                  label={t('INGREDIENT_IMAGE')}
                  name="ingredientImage"
                  headerText={t('ACCEPTED_FORMATS')}
                  footerText={t('PLEASE_UPLOAD')}
                  onClick={() =>
                    openImageDialog(
                      'ViewImage',
                      t('INGREDIENT_IMAGE'),
                      selectedIngredientImage
                    )
                  }
                />
              </Grid>
            )}

            {selectedNutritionImage && (
              <Grid item>
                <BakeasyImgSelectorView
                  uploadState="initFromProps"
                  disabled={true}
                  id="nutritionImage"
                  value={selectedNutritionImage}
                  label={t('NUTRITION_IMAGE')}
                  name="nutritionImage"
                  headerText={t('ACCEPTED_FORMATS')}
                  footerText={t('PLEASE_UPLOAD')}
                  onClick={() =>
                    openImageDialog(
                      'ViewImage',
                      t('NUTRITION_IMAGE'),
                      selectedNutritionImage
                    )
                  }
                />
              </Grid>
            )}

            {qrCode && (
              <Grid item>
                <BakeasyImgSelectorView
                  uploadState="initFromProps"
                  disabled={true}
                  id="qrCode"
                  value={qrCode}
                  label={t('QR_CODE')}
                  name="qrCode"
                  headerText={t('ACCEPTED_FORMATS')}
                  footerText={t('PLEASE_UPLOAD')}
                  onClick={() =>
                    openImageDialog('ViewImage', t('QR_CODE'), qrCode)
                  }
                />
              </Grid>
            )}

            {skuImage && (
              <Grid item>
                <BakeasyImgSelectorView
                  uploadState="initFromProps"
                  disabled={true}
                  id="skuImage"
                  value={skuImage}
                  label={t('SKU_IMAGE')}
                  name="skuImage"
                  headerText={t('ACCEPTED_FORMATS')}
                  footerText={t('PLEASE_UPLOAD')}
                  onClick={() =>
                    openImageDialog('ViewImage', t('SKU_IMAGE'), skuImage)
                  }
                />
              </Grid>
            )}
          </Grid>
        </Paper>
      </Grid>
    );
  }

  return isView ? viewProductUI() : createProductUI();
};
